/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'dismiss': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M12.18 11.246L5.927 4.993l-.079-.066-.1-.06a.665.665 0 00-.755.126l-.076.092a.66.66 0 00.076.842l6.253 6.253-6.253 6.253-.066.079a.664.664 0 00.066.855l.092.076a.66.66 0 00.842-.076l6.253-6.255 6.253 6.255.079.066c.273.19.628.16.855-.066l.076-.092a.66.66 0 00-.076-.842l-6.255-6.253 6.255-6.253.066-.079a.664.664 0 00-.066-.855.662.662 0 00-.934 0l-6.253 6.253z" _fill="#000" fill-rule="evenodd"/>'
  }
})
